import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { ThemeModule } from './@core/theme.module';
import { PagesModule } from './pages/pages.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TransversalesModule } from './pages/transversales/transversales.module';
import { ClipboardModule } from 'ngx-clipboard';

declare const utils: any;

declare global {
  interface Window { utils: any }
}
window.utils = window.utils || utils;
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    ThemeModule,
    PagesModule,
    CommonModule,
    TransversalesModule,
    ClipboardModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 2000,
      extendedTimeOut: 0,
      positionClass: 'toast-bottom-right',
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
